export default "__VITE_ASSET__Bg2hkPoU__"